@if (isLogged) {
  @if (workFlowController) {
    <div class="workflow-steps"
      [ngClass]="{ 'workflow-steps--condensed': isMobileCondensed }"
      >
      @for (workflowBlock of workFlowController?.workflowForMenu; track workflowBlock) {
        <div class="workflow-steps-mode">
          <div class="workflow-steps__title">
            @if (workflowBlock.title && workflowBlock.title()) {
              <div
                class="mb-0_75 mt-1"
                [innerHTML]="workflowBlock.title() | translate:{firstNameApplicant: statement && statement.firstName ? statement.firstName : '', firstNameSpouse: statement && statement.spouse && statement.spouse.firstName ? statement.spouse.firstName : '', statementYear: statement && statement.fullYear ? statement.fullYear : ''}"
              ></div>
            }
          </div>
          @for (workflowStep of workflowBlock?.steps; track workflowStep) {
            @if (workflowStep.isVisible) {
              <div
                class="workflow-steps__steps-list {{workflowStep.stepClass}}"
                [attr.data-cy]="'btnWorkflow_' + workflowStep.constructor.name"
                [class.sub]="workflowStep.isSubStep"
                [class.workflow-steps__steps-list--disabled]="workflowStep.blockedDefaultWorkflow || !workflowStep.canGo"
                (click)="goToStepWorkflow(workflowStep)"
                >
                <div
                  class="workflow-steps__step workflow-steps__step-list"
                  [class.workflow-steps__step--active]="workflowStep.isActive || workflowStep.isActiveOnStepsBar"
                  [class.workflow-steps__step--done]="workflowStep.isDone"
                  >
                  <div class="workflow-steps__step-header">
                    <div class="workflow-steps__step-point"></div>
                    <div class="workflow-steps__step-title">
                      <a
                        [class.mobile-text-long-1]="(workflowStep.title | translate).length > 19"
                        [class.mobile-text-long-2]="(workflowStep.title | translate).length > 23"
                        >
                        {{ workflowStep.title | translate }}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            }
          }
        </div>
      }
    </div>
  }
}

<app-labels-edit [statement]="statement" [currentId]="'selectLabelLeft'"></app-labels-edit>
